export default "__VITE_ASSET__CGJq42yV__"